<!--
  @component
  Generates an HTML scatter plot. This component can also work if the x- or y-scale is ordinal, i.e. it has a `.bandwidth` method. See the [timeplot chart](https://layercake.graphics/example/Timeplot) for an example.
 -->
<script>
  import { getContext } from 'svelte';
  import Food from './Food.svelte';

  const { data, xGet, yGet, xScale, yScale } = getContext('LayerCake');

  export let r = 7;
  export let labels = {};
  export let hovered;

</script>

<div class="scatter-group">
  {#each $data as d}

    <Food
      x={$xGet(d) + ($xScale.bandwidth ? $xScale.bandwidth() / 2 : 0) + '%'}
      y={$yGet(d) + ($yScale.bandwidth ? $yScale.bandwidth() / 2 : 0) + '%'}
      r={r}
      d={d}
      label={labels[d.name]}
      hovered={d.category===hovered}
      hovering={!!hovered}
    />


  {/each}
</div>

<style>
</style>
